import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { InviteHostsService } from '@app/shared/services/invite-hosts/invite-hosts.service';
import { Listing } from '@app/shared/services/settings/settings.service';

@Component({
  standalone: false,
  templateUrl: './host-invite-success.component.html',
  styleUrls: ['./host-invite-success.component.scss'],
})
export class HostInviteSuccessComponent implements OnInit {
  platform: string = 'airbnb-official';
  channnelId: string = '';

  listings: any[];
  loading: boolean;
  submitting: boolean = false;
  invitationUuid: string;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly inviteService: InviteHostsService,
    private readonly router: Router
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.route.paramMap.subscribe((params) => {
      this.channnelId = params.get('channel_id');
      this.invitationUuid = params.get('invitation_uuid');

      this.inviteService
        .fetchListings(this.platform, this.channnelId, this.invitationUuid)
        .subscribe((res: Listing[]) => {
          this.listings = res;
          this.loading = false;
        });
    });
  }

  syncPropertiesSelection() {
    this.submitting = true;

    const selectionStates = this.listings.map(listing => ({
      id: listing.property_id,
      selected: listing.allowAccess,
    }));

    this.inviteService.syncProperties(selectionStates, this.invitationUuid).subscribe(
      (res) => {
        this.router.navigate(['/user/hosts/success/done']);
        this.submitting = false;
      },
      (error) => {
        console.error('Error syncing properties `muted` statuses', error);
        this.submitting = false;
      },
    );
  }
}
